// DS: i10.9
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const Behance: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <path d="M4.833 8.092v2.625c.042.008.07.016.099.016.874.001 1.748.017 2.62-.007.305-.009.62-.081.907-.186.563-.206.78-.674.706-1.398-.055-.52-.362-.861-.933-.944-.47-.07-.95-.09-1.426-.102-.652-.016-1.304-.004-1.973-.004zm-.005 7.8c.067.003.11.008.155.008.867.002 1.733.008 2.6-.004a3.31 3.31 0 0 0 .743-.095c.45-.11.788-.375.962-.811.14-.354.177-.721.114-1.099-.082-.494-.359-.846-.835-1-.312-.1-.65-.16-.98-.17-.864-.022-1.732-.008-2.598-.007-.05 0-.102.01-.161.015v3.162zM8.113 18H2V6.001h.31c1.734 0 3.467-.005 5.199.004.447.002.898.02 1.34.084 1.51.22 2.634 1.117 2.75 2.746.081 1.134-.252 2.079-1.338 2.65-.035.018-.062.052-.103.088.516.198.947.48 1.269.907.51.672.616 1.444.559 2.253-.108 1.512-1.264 2.802-2.777 3.094-.363.07-.73.115-1.096.173zM19.526 12.625c-.055-1.118-.909-1.828-2.121-1.79-1.085.034-1.944.829-1.92 1.79h4.041zM22 14.105l-5.461-.008h-1.106c-.06 1.146.736 1.983 1.827 2.08.416.038.833.027 1.234-.12.375-.139.654-.369.872-.683a.341.341 0 0 1 .233-.136c.717-.01 1.435-.005 2.152-.004.03 0 .06.01.156.025-.119.278-.196.557-.347.797a3.875 3.875 0 0 1-2.358 1.726c-1.458.382-2.862.276-4.198-.433-1.033-.548-1.64-1.375-1.854-2.458-.245-1.24-.228-2.47.336-3.639.622-1.286 1.738-1.983 3.21-2.189.916-.128 1.831-.07 2.697.253 1.464.546 2.232 1.617 2.512 3.03.04.201.063.406.095.609v1.15zM14 8h7V6h-7z" />
      </g>
    </svg>
  </IconWrap>
);
Behance.displayName = 'Behance';

export default Behance;
